import React, { Component } from "react";

import ValidatedRegisterForm from "../components/ValidatedRegisterForm";
import WrappedUp from "../containers/WrappedUp";
import AccountTransactions from "../components/AccountTransactions";
import { useParams } from "react-router-dom";

function TransactionsPage() {
  const params = useParams();

  const { identifier = "" } = params;

  return (
    <WrappedUp>
      <AccountTransactions identifier={identifier} />
    </WrappedUp>
  );
}

export default TransactionsPage;
